// extracted by mini-css-extract-plugin
module.exports = {"imageHero":"ImageHero-module--image-hero--m9kSp","image":"ImageHero-module--image--3nzfJ"};